import chunk from 'lodash/chunk'
import api from '../../plugins/api'

const IMPORT_CHUNK_SIZE = 2000

export default {
  namespaced: true,
  state: {items: [], count: 0, filterParams: {}},
  actions: {
    async countReferences({commit, state}, options) {
      const count = await api.Incentive.countReferences({...state.filterParams, ...options})
      commit('changeState', {count})
    },
    async fetchReferences({commit, state}, options) {
      // paging is not kept in filterParams, so count never receives it
      const {_start, _limit, ...filterParams} = {...state.filterParams, ...options}
      const items = await api.Incentive.findReferences({...filterParams, _start, _limit})
      commit('changeState', {items, filterParams})
    },
    deleteReference(_, id) {
      return api.Incentive.deleteReference(id)
    },
    // The API accepts at most 2000 rows per request; failed[].index is remapped to the position in `rows`
    async importReferences(_, rows) {
      const summary = {total: 0, inserted: 0, updated: 0, failed: []}
      const batches = chunk(rows, IMPORT_CHUNK_SIZE)
      for (let i = 0; i < batches.length; i++) {
        const result = await api.Incentive.importReferences({rows: batches[i]})
        summary.total += result.total || 0
        summary.inserted += result.inserted || 0
        summary.updated += result.updated || 0
        ;(result.failed || []).forEach(item => {
          summary.failed.push({...item, index: i * IMPORT_CHUNK_SIZE + item.index})
        })
      }
      return summary
    },
  },
  getters: {
    items: state => state.items,
    count: state => state.count,
  },
}
